// extracted by mini-css-extract-plugin
export default {"centered":"UserForm_centered__ge3xr","registerMainButton":"UserForm_registerMainButton__zTEKx"};